var SubscriptionType;
(function(SubscriptionType) {
    SubscriptionType[/**
   * Monthly payment, monthly delivery
   */ "MONTHLY"] = "MONTHLY";
    SubscriptionType[/**
   * Quarterly payment, quarterly delivery
   */ "QUARTERLY"] = "QUARTERLY";
    SubscriptionType[/**
   * Monthly payment, quarterly delivery
   * This type has a first payment of three months
   */ "MIXED_MONTHLY"] = "MIXED_MONTHLY";
    SubscriptionType[/**
   * Quarterly payment, monthly delivery.
   */ "MIXED_QUARTERLY"] = "MIXED_QUARTERLY";
})(SubscriptionType || (SubscriptionType = {}));

export { SubscriptionType };
//# sourceMappingURL=subscription-details.js.map
